import styled from 'styled-components'

import { mq, sizes } from '../../theme'

export const AdsShareSocialNetworks = styled.div``

export const Wrapper = styled.div`
  padding: 3.5rem 0;
  display: flex;
  gap: 1.2rem;
  flex-wrap: wrap;
  align-items: center;
`

export const WrapperIcons = styled.div`
  display: flex;
  gap: 2.2rem;
`

export const Title = styled.h5`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  margin: 0 1.1rem 0 0;
  @media ${mq(sizes.tablet)} {
  }
`

export const Separator = styled.div`
  background-image: repeating-linear-gradient(
      0deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      180deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      270deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    );
  background-size: 0, 0, 2px 100%, 100% 2px;
  background-position: 0 0, 0 0, 100% 0, 0 100%;
  background-repeat: no-repeat;
  height: 0.2rem;
  width: 100%;
`
